import React from 'react';
import './DocumentsEmptyState.css';

const CAPABILITIES = [
  { icon: '✏️', label: 'Notes' },
  { icon: '💬', label: 'AI Chat' },
  { icon: '📚', label: 'Study Tools' },
  { icon: '🗂️', label: 'Metadata' },
];

export default function DocumentsEmptyState({
  hasDocuments = false,
  onUploadClick,
}) {
  return (
    <div className="scoulmEmpty">
      <div className="scoulmEmptyState">
        {/* Scout hero image */}
        <img
          className="scoulmScoutImage"
          src="/scout_images/scout_wave_new.png"
          alt="Scout waving"
          draggable={false}
        />

        {/* Eyebrow */}
        <p className="scoulmEyebrow">Scout's Workspace</p>

        {/* Headline */}
        <h2 className="scoulmHeadline">
          {hasDocuments ? 'Welcome back to ScoutLM' : 'Welcome to ScoutLM'}
        </h2>

        {/* Subheadline */}
        <p className="scoulmSubheadline">
          {hasDocuments
            ? 'Select a document on the left to open notes, AI chat, study tools, and metadata.'
            : 'Scout is ready to turn your class documents into notes, AI chat, study tools, and metadata.'}
        </p>

        {/* Upload section */}
        <div className="scoulmUploadSection">
          <button
            type="button"
            className="scoulmUploadBtn btn-branded"
            onClick={onUploadClick}
          >
            Upload documents
          </button>
          <p className="scoulmFormats">
            PDF &bull; DOCX &bull; PPTX &bull; TXT &bull; Markdown
          </p>
        </div>

        {/* Capability chips */}
        <div className="scoulmCapabilities">
          <p className="scoulmCapLabel">What opens up</p>
          <div className="scoulmChips">
            {CAPABILITIES.map((c) => (
              <span key={c.label} className="scoulmChip">
                <span className="scoulmChipIcon">{c.icon}</span>
                {c.label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
